module.exports = __webpack_public_path__ + "static/media/GothamBlack.8e067fbb.woff2";